import React, { Component } from "react";

// import { compose } from "react-apollo";
// import Queries from "../queries/queries2";
import { injectIntl } from "react-intl";

// import rootQuery from "./rootQuery";

// Set Up The Initial Context
const RootContext = React.createContext();
// Create an exportable consumer that can be injected into components
export const RootConsumer = RootContext.Consumer;
// Create the provider using a traditional React.Component class
class RootProvider extends Component {
  constructor(props) {
    super(props);

    const company =
      props.getCompanyInfoForContainer &&
      props.getCompanyInfoForContainer.company;

    this.state = {
      companyId: props.companyId,
      userTiersId: props.userTiersId,
      role: props.role,
      loggedEmail: props.loggedEmail,

      //   company: null,
      invoice: null,
      quotation: null,
      user: props.data && props.data.loggedInUser,
      userId:
        props.data && props.data.loggedInUser && props.data.loggedInUser.id,

      intl: props.intl,
      locale: props.intl && `${props.intl.locale.split("-")[0]}`,
      //   companyCurrency
      getCompanyInfoForContainer: props.getCompanyInfoForContainer,
      company,

      currency: company && company.currency,

      currencyId: company && company.currency.id,

      // updateAccount: updatedAccount => this.updateAccount(updatedAccount)
      setCompany: companyId => {
        this.setState({ companyId });
      }
    };
  }
  //   updateAccount = updatedAccount => {
  //     this.setState(prevState => ({
  //       ...prevState,
  //       ...updatedAccount
  //     }));
  //   };

  componentDidUpdate = (prevProps, prevState) => {
    if (!!!this.props.data || this.props.data.loading) return;

    let newState = {};

    // intl has loaded, store locale up
    if (prevProps.intl && prevProps.intl !== this.props.intl) {
      newState.intl = this.props.intl;
      newState.locale = this.setLocaleFromIntl(newState.intl);
    }

    if (
      !!prevProps.getCompanyInfoForContainer &&
      !!!this.props.getCompanyInfoForContainer.loading &&
      prevProps.getCompanyInfoForContainer !==
        this.props.getCompanyInfoForContainer
    ) {
      newState.getCompanyInfoForContainer = this.props.getCompanyInfoForContainer;
      newState.company = this.props.getCompanyInfoForContainer.company;
      newState.currency = newState.company.currency;
      newState.currencyId = newState.company.currencyId;
    }

    // user has loaded, store it
    if (this.props.data) {
      if (
        (this.props.data.loggedInUser && !prevProps.data.loggedInUser) ||
        prevProps.data.loggedInUser.id !== this.props.data.loggedInUser.id
      ) {
        newState.user = this.props.data.loggedInUser;
      }
    }
    if (
      Object.entries(newState).length > 0 &&
      newState.constructor === Object
    ) {
      this.setState(newState);
    }
  };

  componentDidMount = () => {
    if (this.props.intl) this.setLocaleFromIntl(this.props.intl);
  };

  setLocaleFromIntl = intl => {
    if (intl && intl.locale) {
      const shortLocale = `${intl.locale.split("-")[0]}`;
      if (shortLocale !== "en") {
        require(`moment/locale/${shortLocale}`);
      }
    }
  };

  render() {
    // console.log("112 - RootProvider.render", this.props, this.state);
    return (
      // value prop is where we define what values
      // that are accessible to consumer components
      <RootContext.Provider value={this.state}>
        {this.props.children}
      </RootContext.Provider>
    );
  }
}

export default injectIntl(RootProvider);
// graphql(Queries.getCompanyInfoForContainer, {
//   name: "getCompanyInfoForContainer"
// })
